import { DocumentStatus } from "@src/appV2/Accounts/Documents/types";
import { API_TYPES } from "@src/appV2/api/constants";
import { z } from "zod";

import { HelloSignWorkflowSessionStatus } from "./constants";

const notificationDataAttributesSchema = z.object({
  reason: z.string().optional(),
  note: z.string().optional(),
  pushNotification: z.boolean().optional(),
});

export const hcpDocumentAttributesSchema = z.object({
  hcpId: z.string(),
  requirementId: z.string(),
  uploadedForRequirementId: z.string(),
  status: z.nativeEnum(DocumentStatus),
  expiry: z.string().datetime().optional(),
  name: z.string().min(1),
  displayName: z.string().optional(),
  issueDate: z.string().datetime().optional(),
  archived: z.boolean(),
  createdAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime().optional(),
  reviewedAt: z.string().datetime().optional(),
  notificationUpdatedAt: z.string().datetime().optional(),
  fileStorageRootFolder: z.string().optional(),
  fileStorageFileKey: z.string().optional(),
  subType: z.string().optional(),
  notification: notificationDataAttributesSchema.optional(),
});

export const getHelloSignSessionQueryParamsSchema = z.object({
  include: z.literal(API_TYPES.documents).optional(),
});

export type GetHelloSignSessionQueryParams = z.infer<typeof getHelloSignSessionQueryParamsSchema>;

export const helloSignSessionAttributesSchema = z.object({
  signUrl: z.string().optional(),
  status: z.nativeEnum(HelloSignWorkflowSessionStatus),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type HelloSignSessionAttributes = z.infer<typeof helloSignSessionAttributesSchema>;

export const helloSignSessionResponseSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.helloSignSession),
    attributes: helloSignSessionAttributesSchema,
    id: z.string(),
    relationships: z.object({
      document: z
        .object({
          data: z.object({
            id: z.string(),
            type: z.literal(API_TYPES.documents),
          }),
        })
        .optional(),
      requirement: z.object({
        data: z.object({
          id: z.string(),
          type: z.literal("requirements"),
        }),
      }),
    }),
  }),
  included: z
    .array(
      z.object({
        type: z.literal(API_TYPES.documents),
        id: z.string(),
        attributes: hcpDocumentAttributesSchema,
      })
    )
    .optional(),
});

export type HelloSignSessionResponse = z.infer<typeof helloSignSessionResponseSchema>;
